import React from "react";
import { formatPriceAmount } from "../utils/saleUtils";

const defaultStrikeStyle = {
  fontSize: "22px",
  fontWeight: "normal",
  color: "red",
  textDecoration: "line-through",
  marginRight: "8px",
};

/**
 * Renders sale-aware price: Free, optional strikethrough original, then discounted/current.
 */
export function SalePriceLabel({ salePrice, strikeStyle = defaultStrikeStyle }) {
  if (!salePrice || salePrice.displayDiscounted == null) {
    return <>Free</>;
  }

  return (
    <>
      {salePrice.hasDiscount && (
        <span style={strikeStyle}>
          {formatPriceAmount(salePrice.displayOriginal)}
        </span>
      )}
      <span>{formatPriceAmount(salePrice.displayDiscounted)}</span>
    </>
  );
}

export default SalePriceLabel;
